import { Action, createReducer, on } from '@ngrx/store';
import { setSharedData } from './actions';
import { initialState, SharedState } from './state';
const reducer = createReducer(
  initialState,
  on(setSharedData, (state, { data }) => ({
    ...state,
    pagination: {
      pageNumber: data.pageNumber,
      pageSize: data.pageSize ?? 5,
      totalPages: data.totalPages,
      totalRecords: data.totalRecords,
    },
  })),
);

export function SharedReducer(state: SharedState, action: Action) {
  return reducer(state, action);
}
